import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-mfa-instructions",
	templateUrl: "./mfa-instructions.component.html",
	styleUrls: ["./mfa-instructions.component.css"],
})
export class MfaInstructionsComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@Input() QRImage: string = "";
	@Input() ManualCode: string = "";

	/////////////////////////////////////////////////////////////////
}
